import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { useForm } from '../hooks/form';
import toast from 'react-hot-toast';
import { useCart } from '../stores/cartStore';
import FormInput from './FormInput';

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { checkAuthStatus } = useAuth();
  const { fetchCartItems } = useCart();

  const { form, loading, handleOnChange, errors, login } = useForm({
    email: '',
    password: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    login("/api/login")
      .then((response) => {
        checkAuthStatus();
        fetchCartItems();
        toast.success(t('messages.loginSuccess'));
        navigate('/');
      })
      .catch(({ response }) => {
        if (response?.status === 400) {
          const message = response.data?.message;
          toast.error(message);
        }
      });
  };

  return (
    <div className="px-24 py-40 border border-gray-100 hover-border-main-600 transition-1 rounded-16">
      <h6 className="mb-32 text-xl">{t('common.login')}</h6>
      <form onSubmit={handleSubmit} noValidate>
        <FormInput
          label={t('common.email')}
          name="email"
          value={form.email}
          onChange={handleOnChange}
          errors={errors.email}
          required
        />
        
        <FormInput
          label={t('common.password')}
          type="password"
          name="password"
          value={form.password}
          onChange={handleOnChange}
          errors={errors.password}
          required
        />
        
        <div className="mt-48 mb-24">
          <div className="flex-wrap gap-48 flex-align">
            <button
              type="submit"
              className="px-40 btn btn-main py-18"
              disabled={loading}
            >
              {loading ? t('common.loggingIn') : t('common.login')}
            </button>
            <div className="form-check common-check">
              <input
                className="form-check-input"
                type="checkbox"
                defaultValue=""
                id="remember"
              />
              <label
                className="form-check-label flex-grow-1"
                htmlFor="remember"
              >
                {t('common.rememberMe')}
              </label>
            </div>
          </div>
        </div>
        <div className="mt-48">
          <Link
            to="#"
            className="text-sm text-danger-600 fw-semibold hover-text-decoration-underline"
          >
            {t('common.forgotPassword')}
          </Link>
          <p className="mt-24">
            {t('common.noAccount')}
            <Link to="/register" className="tw-ml-2 text-main-600 text-decoration-underline">
              {t('common.register')}
            </Link>
          </p>
        </div>
      </form>
    </div>
  );
};

export default Login;
